import { render, staticRenderFns } from "./DevicesTable.vue?vue&type=template&id=2af5f110"
import script from "./DevicesTable.vue?vue&type=script&lang=js"
export * from "./DevicesTable.vue?vue&type=script&lang=js"
import style0 from "./DevicesTable.vue?vue&type=style&index=0&id=2af5f110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports